import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function Navbar() {
  const { t } = useTranslation();
  const location = useLocation();
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 60);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location]);

  const isActive = (path: string) => location.pathname === path;

  return (
    <nav
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-sm shadow-sm'
          : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 md:px-6 flex items-center justify-between h-16 md:h-18">
        <Link to="/" className="flex items-center gap-2 whitespace-nowrap cursor-pointer">
          <span className="text-xl md:text-2xl font-heading text-primary-500 font-bold">
            {t('site.name')}
          </span>
        </Link>

        <div className="hidden md:flex items-center gap-8">
          <Link
            to="/"
            className={`text-sm font-medium transition-colors duration-200 whitespace-nowrap cursor-pointer ${
              isActive('/')
                ? 'text-primary-500'
                : 'text-foreground-700 hover:text-primary-500'
            }`}
          >
            {t('nav.home')}
          </Link>
          <Link
            to="/category/daily"
            className={`text-sm font-medium transition-colors duration-200 whitespace-nowrap cursor-pointer ${
              location.pathname.startsWith('/category')
                ? 'text-primary-500'
                : 'text-foreground-700 hover:text-primary-500'
            }`}
          >
            {t('nav.categories')}
          </Link>
          <Link
            to="/about"
            className={`text-sm font-medium transition-colors duration-200 whitespace-nowrap cursor-pointer ${
              isActive('/about')
                ? 'text-primary-500'
                : 'text-foreground-700 hover:text-primary-500'
            }`}
          >
            {t('nav.about')}
          </Link>
        </div>

        <button
          className="md:hidden w-10 h-10 flex items-center justify-center cursor-pointer text-foreground-700"
          onClick={() => setMobileOpen(!mobileOpen)}
          aria-label="Toggle menu"
        >
          <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
        </button>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200/70 px-4 py-4 flex flex-col gap-3">
          <Link
            to="/"
            className={`text-sm font-medium py-2 cursor-pointer ${
              isActive('/') ? 'text-primary-500' : 'text-foreground-700'
            }`}
          >
            {t('nav.home')}
          </Link>
          <Link
            to="/category/daily"
            className={`text-sm font-medium py-2 cursor-pointer ${
              location.pathname.startsWith('/category')
                ? 'text-primary-500'
                : 'text-foreground-700'
            }`}
          >
            {t('nav.categories')}
          </Link>
          <Link
            to="/about"
            className={`text-sm font-medium py-2 cursor-pointer ${
              isActive('/about') ? 'text-primary-500' : 'text-foreground-700'
            }`}
          >
            {t('nav.about')}
          </Link>
        </div>
      )}
    </nav>
  );
}